import React, { Component } from 'react'
import {
    MDBContainer,
    MDBBtn,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalFooter,
    MDBIcon,
    MDBRow,
  MDBCol,
  MDBView
  } from 'mdbreact';
  import { api } from '../../api';
  // import { apipic } from '../../api';
  import Swal from 'sweetalert2'
  //import Axios from 'axios'

export default class Modalshowcitizen extends Component {
    constructor(props) {
        super(props);
this.state = {
    modal: false,
    id_room:'',
    room:[],
    loading:false,
    pic:'',

}

 this.updatestatusopenroom = this.updatestatusopenroom.bind(this);
 this.toggle = this.toggle.bind(this);
// this.handleChange3 = this.handleChange3.bind(this);
// this.handleSubmit = this.handleSubmit.bind(this);
// this.toggle = this.toggle.bind(this);
// this.handleChange4 = this.handleChange4.bind(this);
//this.getExpert = this.getExpert.bind(this);
}

toggle = () => {
    this.setState({
      modal: !this.state.modal,
      id_room: this.props.id_room
    });
  }

  componentDidMount() {
   // const { id_room } = this.props.id_room

   // console.log(id_send);
  //  this.setState({ id_room:this.props.id_room})
    setTimeout(() => {
        api.get('lkselectroomtimecheckid.php?id_time='+this.props.id_time)
        .then(res => {
        //  console.log(res);
        this.setState({ room: res.data,
            pic: res.data[0].pic_idcard,
            loading: false })
        }) 

    }, 0);

}

  updatestatusopenroom (){
           
    setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id", this.state.id_room);
      api.post("lkupdatestatusroom.php",datafrm,{
       headers: {
                 'content-type': 'multipart/form-data'
                }
                })
                        .then(res => {
                           // console.warn(res);
                           // console.log("response: ", res)
                            if (res.status=== 200) {

                          Swal.fire({
                            title: 'เปิดห้องสำเร็จ',
                            icon: 'success',
                          // showCancelButton: true,
                            confirmButtonText: 'ตกลง',
                          // cancelButtonText: 'No, keep it'
                          }).then((result) => {
                          //  this.props.getroom();
                            this.toggle();
                           // this.getwork();
                           // window.location.href = '/'
                          })

                            }else{
                            // window.location.href = '/'
                            }

                        })

            }, 1000);

  }


  render() {
 //   console.log(this.state.pic)
    return (
      <MDBContainer>
        <MDBBtn color="dark" onClick={this.toggle}><MDBIcon icon="chalkboard-teacher" /> แสดงภาพ</MDBBtn>
        <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
          <MDBModalHeader toggle={this.toggle}>แสดงภาพ </MDBModalHeader>

          <MDBModalBody>
          <h3><MDBIcon icon="person-booth" /> ห้องที่ {this.props.numberroomck}</h3> 
          <p><MDBIcon far icon="clock" /> เวลาเข้า: {this.props.timestart} || <MDBIcon icon="clock" /> เวลาออก: {this.props.timeend} </p> 
          {/* <MDBBtn color="deep-purple" onClick={this.updatestatusopenroom}>เปิดใช้ห้อง</MDBBtn> */}
          <MDBRow>
          <MDBCol lg="12">
            
            <MDBView  waves>
              <img src= {`https://luckyresortkpp.com/luckybackend/${this.state.pic}`} className="rounded mx-auto d-block" alt="" />
            </MDBView>
          
          </MDBCol>
         
        </MDBRow>
          </MDBModalBody>

          <MDBModalFooter>
            <MDBBtn color="secondary" size="sm" onClick={this.toggle}>ปิด</MDBBtn>
            {/* <MDBBtn color="primary" size="sm">Save changes</MDBBtn> */}
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
    )
  }
}
